import type { Plugin, InjectionKey } from 'vue'
import { Configuration, FrontendApi } from '@ory/client'
import type { Session } from '@ory/client'

export const Ory = new FrontendApi(
  new Configuration({
    basePath: import.meta.env.VITE_APP_ORY_BACKEND_URL,
    baseOptions: {
      withCredentials: true,
    },
  }),
)

export const $ory: InjectionKey<typeof Ory> = Symbol('$ory')
export const $session: InjectionKey<Session> = Symbol('$session')
export const $ory_urls: InjectionKey<{
  logoutUrl: string
}> = Symbol('$ory_urls')

export const OryPlugin: Plugin = {
  install(app) {
    // can now be used with inject($ory)
    app.provide($ory, Ory)

    Promise.all([
      // get the logout url
      Ory.createBrowserLogoutFlow().catch(() => ({
        data: {
          logout_url: '',
        },
      })),
    ]).then(([{ data: logoutData }]) => {
      app.provide($ory_urls, {
        logoutUrl: logoutData.logout_url,
      })
    })
  },
}
